import { OneContextStore } from '../../../one-context';
import { UserCentricsConsentState } from '../consent-context-connection/types';
import { subscribe } from '@seamless/one-context';
import { TENANT } from '../../../constants/index';
import { Dispatch, Reducer, UnknownAction } from 'redux';
import { isBrowser } from '../../../utils';
import { ABTestingConnectionDispatchers, ABTestingConnectionState } from './types';
import {
  getAllABTestingCookies,
  getParamsWithPrefix,
  removeAllABTestingCookies,
  setCookieFromQueryParams,
} from './utils';

export const abTestingConnectionName = 'AB_TESTING_CONNECTION';
const CONSENT_NAME = 'A/B-Testing';
const CONSENT_CONNECTION_NAME = 'ConsentContextConnection';
const UPDATE_AB_TESTING = 'UPDATE_AB_TESTING';

const initialState: ABTestingConnectionState = {};

export class ABTestingConnection extends OneContextStore<ABTestingConnectionDispatchers, ABTestingConnectionState> {
  readonly allowedTenants = [TENANT];

  constructor() {
    super(abTestingConnectionName);
  }

  get initialState(): ABTestingConnectionState {
    return initialState;
  }

  private getState(): ABTestingConnectionState {
    if (!isBrowser()) {
      return {};
    }

    /* v8 ignore next 1 */
    const topMostWindow = window.top || window;

    const urlSearchParams = new URLSearchParams(topMostWindow.location.search);
    const abTestingParams = getParamsWithPrefix(urlSearchParams);

    if (Object.keys(abTestingParams).length > 0) {
      setCookieFromQueryParams(abTestingParams);
      return abTestingParams;
    }

    return getAllABTestingCookies();
  }

  async onBeforeRegister(dispatch: Dispatch<UnknownAction>) {
    subscribe(CONSENT_CONNECTION_NAME, {
      tenant: TENANT,
      componentName: abTestingConnectionName,
      callback: (state: UserCentricsConsentState[]) => {
        (async () => {
          const consent = state.find((consent) => consent.name === CONSENT_NAME);

          if (consent?.enabled) {
            const afterConsentAction = this.getAction(UPDATE_AB_TESTING, this.getState());
            dispatch(afterConsentAction);
          } else if (state.length > 0 && !consent?.enabled) {
            removeAllABTestingCookies();
            dispatch(this.getAction(UPDATE_AB_TESTING, {}));
          }
        })();
      },
    });
  }

  getReducer(): Reducer {
    return (state = this.initialState, action: any) => {
      if (action.type === this.getActionType(UPDATE_AB_TESTING)) {
        return { ...state, ...action.payload };
      }

      return state;
    };
  }

  public getPublicDispatchers(): ABTestingConnectionDispatchers {
    // State will not happen since it will come either from cookie or from URL
    return {};
  }
}

// Exporting all types
export type { ABTestingConnectionState, ABTestingConnectionDispatchers };
